<template>
  <footer class="footer-container">
    <div class="container-sarah">
      <menu-footer />
    </div>
    <div class="build-number">
      {{ buildVer }}
    </div>
  </footer>
</template>

<script>
import MenuFooter from '@/components/shared/footer/MenuFooter'
export default {
  components: {
    MenuFooter
  },
  computed: {
    buildVer() {
      return process.env.VUE_APP_BUILD_VER
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/styleguide';
.footer-container {
  background-color: var(--bg-color-footer);
  padding: 2.5rem 0 1.25rem;
  font-size: 0.9em;
  position: relative;
  &:after {
    content: '';
    max-width: 53.9375rem;
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/images/sarah_pattern_stripes.png');
    background-position: right;
    background-repeat: repeat-y;
    background-size: cover;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }
  .container {
    z-index: 11;
  }
  .build-number {
    position: absolute;
    right: 5px;
    bottom: 0;
    z-index: 99;
    color: var(--white);
    font-size: 0.6em;
  }
}
</style>
